import Template from 'ln/template/TemplateManager';
import setup from 'ln/setup/setup';
import moment from 'moment';

var context = Template.context;

context.imagePath = function ( image:{ file_name:string }, preset:string = 'medium', ext:string = 'png') {
	if( image ) return decodeURIComponent( setup.route('assets.image', {file_name: image.file_name, preset: preset, ext: ext}).url() );
	return '';
}

context.userFilePath = function( id:string ){
	return decodeURIComponent( setup.route( 'api.userfiles.download', { id: id } ).url() );
};

context.uploadFilePath = function( str:string = '' ){
	// clean target attribute
	// var str = str.replace( /target="_blank"/, '' );
	return str.replace( new RegExp( 'app:\\/\\/download\\/([^"]+)', 'g' ), setup.route( 'download.file', { id: '$1' } ).url() );
}

context.renderDate = function( date:string, inputFormat:string = 'YYYY-MM-DD HH:mm:ss', outputFormat:string = 'DD.MM.YYYY' ) {
	var temp = moment( date, [ inputFormat ] );
	return temp.format( outputFormat );
}

context.truncate = function( str:string = '', length:number = 30, symbol:string = '…' ) {
	return ( str.length > length ) ? str.slice( 0, length - symbol.length) + symbol : str;
}

context.env = function(){
	return setup.data( 'env' );
}

export default context;